import React from 'react';
import Icon from '@ant-design/icons';
import { ButtonType, Button } from 'components/Controls/Button';
import { SizeType } from 'antd/lib/config-provider/SizeContext';
import PlusRoundedSvg from './plusRounded.svg';

type IconButtonProps = {
  size?: SizeType,
  iconSize?: number,
  onClick?: React.MouseEventHandler<HTMLElement>,
  type?: ButtonType,
};

export const PlusRoundedIcon = (props: any) => <Icon component={PlusRoundedSvg} {...props} />;

export const PlusRoundedIconButton = React.forwardRef<HTMLButtonElement | HTMLAnchorElement, IconButtonProps>(
  ({ size = 'medium', type = ButtonType.OutlineIcon, iconSize = 24, ...props }, ref) => (
    <Button
      ref={ref}
      type={type}
      icon={<PlusRoundedSvg with={iconSize} height={iconSize} />}
      size={size}
      {...props}
    />
  ),
);
PlusRoundedIconButton.displayName = 'PlusRoundedIconButton';
